export default class CartTableController {
    /* @ngInject */
    constructor($modal, $location) {
        this.$location = $location;
    }

    showDetails(id) {
        this.$location.path(`/detail/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/home/cart-table/cart-table.controller.js